import React, { useEffect } from 'react';
import cx from 'classnames';
import SamplePreviewCustom from 'paper/components/SamplePreviewCustom';
import { CtaEventDataType, trackCtaClicked, trackCtaViewed } from '@zola-helpers/client/dist/es';
import type {
  SingleSampleAccessPointUIProps,
  CustomTemplateSummary,
  CardSuiteInfoSummary,
} from '../../../util/types';
import styles from './APSamplePreviewListingCard.module.less';

interface APSamplePreviewListingCardProps extends SingleSampleAccessPointUIProps {
  customPreviewTemplates?: CustomTemplateSummary[];
  customPhotoUrl?: string;
  customHandleClick?: () => void;
  cardSuiteInfo?: CardSuiteInfoSummary;
  displayCardName?: boolean;
  trackingPayload: CtaEventDataType;
  entryPoint?: string;
  enableColorPicker?: boolean;
  customClassName?: string;
  isDigital?: boolean;
  showHand?: boolean;
  isUnderDstdWebsiteEntrypointTest?: boolean;
}

const APSamplePreviewListingCard: React.FC<APSamplePreviewListingCardProps> = ({
  handleOpenModal,
  customHandleClick,
  customPreviewTemplates,
  customPhotoUrl,
  cardSuiteInfo,
  displayCardName = true,
  trackingPayload,
  entryPoint = 'SUPER_LINK',
  enableColorPicker,
  customClassName,
  isDigital,
  showHand,
  isUnderDstdWebsiteEntrypointTest,
}) => {
  const name = cardSuiteInfo?.sampleCard?.lead_card?.name;
  const formattedName = name && name.split(' - ')[1];

  useEffect(() => {
    trackCtaViewed(trackingPayload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (): void => {
    if (customHandleClick) {
      customHandleClick();
    } else {
      trackCtaClicked(trackingPayload);
      if (handleOpenModal) {
        handleOpenModal({ entryPoint });
      }
    }
  };

  let templateSize = 234;

  if (isUnderDstdWebsiteEntrypointTest) {
    templateSize = isDigital ? 178 : 215;
  }

  return (
    <SamplePreviewCustom
      customPreviewTemplates={customPreviewTemplates}
      customPhotoUrl={customPhotoUrl}
      onClick={handleClick}
      samplePreviewPropOverrides={{
        className: cx(styles.samplePreview, customClassName, {
          [styles.samplePreview]: !isUnderDstdWebsiteEntrypointTest,
          [styles.digitalSamplePreview]: isUnderDstdWebsiteEntrypointTest && isDigital,
          [styles.paperSamplePreview]: isUnderDstdWebsiteEntrypointTest && !isDigital,
        }),
        templateSize,
      }}
      productColorPickerPropOverrides={{ swatchWidth: 24, maxColorsToShow: 6 }}
      enableColorPicker={enableColorPicker}
      showHand={showHand}
      isUnderDstdWebsiteEntrypointTest={isUnderDstdWebsiteEntrypointTest}
    >
      {displayCardName && <div className={styles.cardName}>{formattedName}</div>}
      {!displayCardName && !isDigital && <div className={styles.spaceHolder} />}
    </SamplePreviewCustom>
  );
};

export default APSamplePreviewListingCard;
